(ns practitest.frontend.permutations.subs
  (:require
   [re-frame.core :as re-frame]
   [clojure.string :as string]))

(re-frame/reg-sub
 :permutations/fields
 (fn [db _]
   (:permutations-data db)))

(re-frame/reg-sub
 :permutations/permutation-set-ids
 (fn [db _]
   (:set-display-ids db)))

(re-frame/reg-sub
 :permutations/checkbox-state
 (fn [db [_ field-id option-id]]
   (boolean (get-in db [:checkboxes field-id option-id]))))

(re-frame/reg-sub
 :permutations/text-field-value
 (fn [db [_ field-id]]
   (get-in db [:text-fields field-id])))

(re-frame/reg-sub
 :permutations/screen
 (fn [db _]
   (:screen db)))

(re-frame/reg-sub
 :permutations/optional-text
 (fn [db _]
   (:filter_name db)))

(re-frame/reg-sub
 :permutations/permutations
 (fn [db _]
   (:permutations db)))

(re-frame/reg-sub
 :permutations/permutations-checked
 (fn [db _]
   (:permutations-checked db)))

(re-frame/reg-sub
 :permutations/testsetids-counter
 (fn [db _]
   (count  (:set-ids db))))

(re-frame/reg-sub
 :permutations/selected-sets
 (fn [db _]
   (:selected-sets db)))

(re-frame/reg-sub
 :permutations/selected-instances
 (fn [db _]
   (:selected-instances db)))

(re-frame/reg-sub
 :permutations/name
 (fn [db _]
   (:name db)))

(re-frame/reg-sub
 :permutations/entities-limit
 (fn [db _]
   (:entities-limit db)))

(re-frame/reg-sub
 :permutations/testset-counter
 (fn [db _]
   (* (:selected-sets db)
      (count (filter last (:permutations-checked db))))))

(re-frame/reg-sub
 :permutations/instances-counter
 (fn [db _]
   (let [n (if (:failed-tests-only-checkbox db)
             (:selected-failed-instances db)
             (:selected-instances db))]
     (* n (count (filter last (:permutations-checked db)))))))

(re-frame/reg-sub
 :permutations/count-permutations
 (fn [db _]
   (count (:permutations-checked db))))

(re-frame/reg-sub
 :permutations/text-fields
 (fn [db _]
   (:text-fields db)))

(re-frame/reg-sub
 :permutations/next-step-disabled?
 (fn [db _]
   (and (empty? (filter (fn [[_ vs]]
                          (boolean (first (filter last vs))))
                        (:checkboxes db)))
        (empty? (remove (comp string/blank? last) (:text-fields db))))))

(re-frame/reg-sub
 :permutations/finish-disabled?
 (fn [db _]
   (or
    (< @(re-frame/subscribe [:permutations/entities-limit])
       @(re-frame/subscribe [:permutations/instances-counter]))
    (empty? (filter last (:permutations-checked db))))))
